// src/components/Summary/Summary.tsx
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import './style.css';
import { useAuth } from '../../Context/UserContext/index.tsx';

export default function Summary() {
  const [questions, setQuestions] = useState([]);
  const { courseId, username, batchNo, setExamStatus } = useAuth();

  useEffect(() => {
    const fetchSummary = async () => {
      try {
        const res = await axios.get(`https://elearn-api.onrender.com/api/questions/${username}/${batchNo}/${courseId}`);
        setQuestions(res.data);
      } catch (error) {
        console.error('Error fetching summary:', error);
      }
    };

    fetchSummary();
  }, [username, batchNo, courseId]);

  const totalMarks = questions.reduce((acc, curr) => acc + (parseFloat(curr?.Marks || 0)), 0);
  const totalQuestions = questions.length;
  const percentage = totalQuestions > 0 ? ((totalMarks / totalQuestions) * 100).toFixed(2) : 0;
  const passPercentage = questions[0]?.Pass ? parseFloat(questions[0].Pass) : 0;
  const isPassed = parseFloat(percentage) >= passPercentage;

  // Update global exam status
  useEffect(() => {
    if (questions.length > 0) {
      setExamStatus(isPassed ? 'Pass' : 'Fail');
    }
  }, [questions, isPassed, setExamStatus]);

  return (
    <div className="summary-container">
      <h1>MCQ Summary</h1>

      {totalQuestions === 0 ? (
        <p>No data available.</p>
      ) : (
        <>
          <table className="summary-table">
            <thead>
              <tr>
                <th scope="col">Question</th>
                <th scope="col">Correct Answer</th>
                <th scope="col">Selected Answer</th>
                <th scope="col">Marks</th>
              </tr>
            </thead>
            <tbody>
              {questions.map((item, index) => (
                <tr key={index}>
                  <td>{item.question}</td>
                  <td>{item.option_ans}</td>
                  <td className={item.option_ans === item.Selectedanswer ? 'correct' : 'wrong'}>
                    {item.Selectedanswer}
                  </td>
                  <td>{item.Marks}</td>
                </tr>
              ))}
            </tbody>
          </table>

          <div className="summary-footer">
            <p><strong>Total Questions:</strong> {totalQuestions}</p>
            <p><strong>Total Marks Obtained:</strong> {totalMarks}</p>
            <p><strong>Percentage:</strong> {percentage}%</p>
            <p>
              <strong>Status:</strong>{' '}
              <span className={isPassed ? 'pass' : 'fail'}>
                {isPassed ? 'Pass' : 'Fail'}
              </span>
            </p>
          </div>
        </>
      )}
    </div>
  );
}
